import { __decorate } from "tslib";
import { computed } from 'mobx';
import ColumnGroup from './ColumnGroup';
export default class ColumnGroups {
    constructor(columns, parent) {
        this.parent = parent;
        let prev;
        this.columns = columns.map(col => {
            const group = new ColumnGroup(col, this);
            if (prev) {
                prev.next = group;
                group.prev = prev;
            }
            prev = group;
            return group;
        });
    }
    get wide() {
        return this.columns.reduce((sum, { colSpan, hidden }) => (hidden ? sum : sum + colSpan), 0);
    }
    get deep() {
        return Math.max(...this.columns.map(({ deep }) => deep));
    }
    get hidden() {
        return this.columns.every(({ hidden }) => hidden);
    }
    get lastLeaf() {
        const avaliableColumns = this.columns.filter(column => !column.hidden);
        return avaliableColumns[avaliableColumns.length - 1].lastLeaf;
    }
    get width() {
        return this.columns.reduce((sum, { width }) => sum + width, 0);
    }
    get left() {
        const { parent } = this;
        if (parent) {
            return parent.left;
        }
        return 0;
    }
    get right() {
        const { parent } = this;
        if (parent) {
            return parent.right;
        }
        return 0;
    }
}
__decorate([
    computed
], ColumnGroups.prototype, "wide", null);
__decorate([
    computed
], ColumnGroups.prototype, "deep", null);
__decorate([
    computed
], ColumnGroups.prototype, "hidden", null);
__decorate([
    computed
], ColumnGroups.prototype, "lastLeaf", null);
__decorate([
    computed
], ColumnGroups.prototype, "width", null);
__decorate([
    computed
], ColumnGroups.prototype, "left", null);
__decorate([
    computed
], ColumnGroups.prototype, "right", null);
